import { computed }          from 'mobx';
import NewFondationsApiModel from 'models/global/NewFondationsApiModel';

export default class EntityCategoryModel extends NewFondationsApiModel {
	static get path(): string {
		return '/entity_categories/{?id}';
	}

	@computed
	public get label() {
		return this.get('label');
	}

	@computed
	public get reference() {
		return this.get('reference');
	}
}
